import React, { useCallback, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux"; // 1. Import Redux hooks
import Translation from "../../../common/translation/translation.component";
import { MODAL_CUSTOM_MESSAGE, TABLE_PAGINATION_KEY } from "../../../../constants/external-constants";
import { DetailsDashboard } from "../../../common/details-dashboard/details-dashboard-layout";
import { TablePagination } from "../../../common/details-table/table-pagination.component";
import { RequestHeaders } from "../../../common/header-logo/request-header.component";
import { NoSubscription } from "../../dashboard/no-subscription/no-subscription.component";
import { data, GENERATED_FILES_DATA, headers, pagination } from "../../../common/sample-data/output-record.data";
import { AccountPayableActions } from "../../../../store/external/invoice/account-payable/account-payable.reducer";
import { validateAccessModule } from "../../../../utils/helpers.utils";
import { ACCESS_MODULE, MATRIX_INDICATOR } from "../../../../utils/rbac-constants.utils";

// 2. The component no longer receives Redux state/actions from props
const AccountPayable = () => {
    const [displaySearch, setDisplaySearch] = useState(false);
    const [countrySelection, setCountrySelection] = useState(null);
    const [vendorSelection, setVendorSelection] = useState(null);
    const [accountNumberSelection, setAccountNumberSelection] = useState(null);
    const [invoiceStatusSelection, setInvoiceStatusSelection] = useState(null);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [exportAlertMsg, setExportAlertMsg] = useState(MODAL_CUSTOM_MESSAGE.export_alert_message);
    const headerTitle = "AccountPayable";

    const dispatch = useDispatch();

    
    const {  
            totalCount, 
            vendorTotalCount,
            accountNumbersTotalCount,
            invoiceStatusTotalCount
         } = useSelector(
        (state) => state.invoiceAccountPayableDetails
    );

    const vendorResetKey = `vendor-${JSON.stringify(countrySelection)}`;
    const accountNumberKey = `account-${JSON.stringify(vendorSelection)}`;
    const invoiceStatusKey = `invoice-${JSON.stringify(accountNumberSelection)}`;
                                
                                
    useEffect(() => {
        setVendorSelection(null);
        setAccountNumberSelection(null);
        setInvoiceStatusSelection(null);
    }, [countrySelection]);

    useEffect(() => {
        setAccountNumberSelection(null);
        setInvoiceStatusSelection(null);
    }, [vendorSelection]);

    useEffect(() => {
        setInvoiceStatusSelection(null);
    }, [accountNumberSelection]);

    useEffect(()=>{
        console.log(vendorSelection)
    },[vendorSelection])
    
    const displaySearchBox = () => setDisplaySearch(prev => !prev);

    const onClickExtract = () => { 
        if (window.confirm(exportAlertMsg)) {

        } };

    const handleRowClick = (rowData) => {

    };
    const onChangeExtractAlertMsg = (val) => setExportAlertMsg(val);
    const loading = () => <NoSubscription />;
    const resizePage = (value) => {

    };
    const applyFilter = (isApply) => {

    };

    const handleDateRangeChange = (dates) => {
        
        console.log("Date Range Updated:", dates);
    };

    const handleFirstOptionListLoadMore = useCallback(async (params) => {
        const res = await dispatch(AccountPayableActions.fetchListCountries(params.offset, params.query));        
        const hasMore = (params.offset + res.items.length) < totalCount;
        
        return {
            items: res.items,
            hasMore: hasMore
        };
    }, [dispatch, totalCount]);

    const handleSecondOptionListLoadMore = useCallback(async (params) => {
        const res = await dispatch(AccountPayableActions.fetchListVendors(params.offset, params.query, countrySelection));
        const hasMore = (params.offset + res.items.length) < vendorTotalCount;

        return {
            items: res.items,
            hasMore: hasMore
        }
    },[dispatch, vendorTotalCount, countrySelection]);

    const handleThirdOptionListLoadMore = useCallback(async (params)=>{
        const res = await dispatch(AccountPayableActions.fetchListAccountNumber(params.offset, params.query, vendorSelection));
        const hasMore = (params.offset + res.items.length) < accountNumbersTotalCount;

        return {
            items: res.items,
            hasMore: hasMore
        }
    },[dispatch, accountNumbersTotalCount, vendorSelection])

    const handleFourthOptionListLoadMore = useCallback(async (params)=>{
        const res = await dispatch(AccountPayableActions.fetchInvoiceStatus());
        const hasMore = (params.offset + res.items.length) < invoiceStatusTotalCount;
        return {
            items: res.items,
            hasMore: hasMore
        }
    },[dispatch, invoiceStatusTotalCount])

    const isVendorDisabled = !countrySelection || 
                            (
                                !countrySelection.isSelectAllGlobal &&
                                countrySelection.selectAllFilters.length === 0 && 
                                countrySelection.selectedKeys.length === 0
                            );

    const isAccountNumberDisabled = !vendorSelection || 
                            (
                                !vendorSelection.isSelectAllGlobal &&
                                vendorSelection.selectAllFilters.length === 0 && 
                                vendorSelection.selectedKeys.length === 0
                            );
    
    const isInvoiceStatusDisabled = !accountNumberSelection || 
                            (
                                !accountNumberSelection.isSelectAllGlobal &&
                                accountNumberSelection.selectAllFilters.length === 0 && 
                                accountNumberSelection.selectedKeys.length === 0
                            );    

    const isDateRangeDiabled = !invoiceStatusSelection || 
                            (
                                !invoiceStatusSelection.isSelectAllGlobal &&
                                invoiceStatusSelection.selectAllFilters.length === 0 && 
                                invoiceStatusSelection.selectedKeys.length === 0
                            );    

    const isReadAndExtractOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdInvoiceAccountsPayableRE])
    const isReadAndWrite = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdInvoiceAccountsPayableRW])
    const isReadOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdInvoiceAccountsPayableR])
    return (
        <>
            <div className="invoice-wrapper-container inventory-report-component">
                <Translation
                    getOnlyText={true}
                    onChangeTranslation={onChangeExtractAlertMsg}
                    translationKey={"export_alert_message"}
                />
                <RequestHeaders headerTitle={headerTitle} />
                <div className="request-table data-table fit-width">
                    <DetailsDashboard
                        data={[]}
                        translation={""}
                        addAction={() => {}}
                        removeAction={() => {}}
                        applyAction={applyFilter}
                        customClassName={""}
                        createNewAction={() => {}}
                        isCreateButtonHidden
                        isCustomColumns
                        viewSearchAction={displaySearchBox}
                        firstList={[]}
                        secondList={[]}
                        defaultList={[]}
                        saveAction={() => {}}
                        extractAction={onClickExtract}
                        isReadOnly={isReadOnly}
                        isReadAndExtractOnly={isReadAndExtractOnly}
                        isReadAndWrite={isReadAndWrite}
                        dropdownExtract={true}
                        extractListLabel={'Extract AP Report'}

                        //send email
                        haveEmail={true}
                        onClickSendEmail={()=>{}}

                        //MultiSelect
                        isGenerate={true}                       
                        handleFirstOptionListLoadMore={handleFirstOptionListLoadMore}
                        handleSecondOptionListLoadMore={handleSecondOptionListLoadMore}
                        handleThirdOptionListLoadMore={handleThirdOptionListLoadMore}
                        handleFourthOptionListLoadMore={handleFourthOptionListLoadMore}
                        onDateRangeChange={handleDateRangeChange}

                        //Fetching Data From Multi Select
                        onFirstMultipleSelect={setCountrySelection}
                        onSecondMultipleSelect={setVendorSelection}
                        onThirdMultipleSelect={setAccountNumberSelection}
                        onFourthMultipleSelect={setInvoiceStatusSelection}


                        //reset field
                        vendorResetKey={vendorResetKey}
                        accountResetKey={accountNumberKey}
                        invoiceStatusKey={invoiceStatusKey}

                        //disabled field                    
                        secondOptionListIsDisabled={isVendorDisabled}
                        thirdOptionListIsDisabled={isAccountNumberDisabled}
                        fourthOptionListIsDisabled={isInvoiceStatusDisabled}
                        dateRangeIsDisabled={isDateRangeDiabled}
                    >
                        {true ? (
                            <TablePagination
                                key={{}}
                                tablePaginationKey={TABLE_PAGINATION_KEY.outputRecord}
                                classNameWrapper="overflow-auto"
                                columns={headers}
                                pageList={data}
                                pages={pagination}
                                rowClickAction={handleRowClick}
                                paginationAction={() => {}}
                                onColumnClick={() => {}}
                                onColumnSearch={() => {}}
                                onColumnSearchChange={() => {}}
                                isColSearchShow={displaySearch}
                                resizePage={{}}
                                totalPage={{}}
                                hideStatusIcon={false}
                            />
                        ) : loading()}
                    </DetailsDashboard>                  
                </div>
            </div>
        </>
    );
};

export default AccountPayable;